import React from 'react'
import {Navigate, Outlet} from 'react-router-dom'
import {useAppSelector} from '../../store/store-hooks'
import {isEmpty} from '../../utils'

interface PrivateRouteProps {
  children?: React.ReactNode
}

/**
 * PrivateRoute for React Router v6
 * 
 * Usage:
 * - As a wrapper: <Route path="/admin" element={<PrivateRoute><AdminPage /></PrivateRoute>} />
 * - With Outlet for nested routes: <Route element={<PrivateRoute />}><Route path="..." /></Route>
 */
export default function PrivateRoute({children}: PrivateRouteProps): JSX.Element {
  const {currentUser} = useAppSelector((state) => state.root)

  if (isEmpty(currentUser)) {
    return <Navigate to="/signin" replace />
  }

  // If children provided, render them; otherwise render Outlet for nested routes
  return children ? <>{children}</> : <Outlet />
}
